import React, { useState } from 'react';
import { CheckCircle2, Loader2, Phone } from 'lucide-react';
import { business } from '../data/business';
import { services } from '../data/services';
type Status = 'idle' | 'submitting' | 'success';
export function QuoteForm() {
  const [status, setStatus] = useState<Status>('idle');
  const [selected, setSelected] = useState<string[]>(['windows']);
  const [error, setError] = useState<string | null>(null);
  const toggleService = (id: string) => {
    setSelected(prev => prev.includes(id) ? prev.filter(s => s !== id) : [...prev, id]);
  };
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (selected.length === 0) {
      setError('Pick at least one service so Mason knows what to price.');
      return;
    }
    setError(null);
    setStatus('submitting');
    window.setTimeout(() => setStatus('success'), 900);
  };
  return <section id="quote" className="w-full bg-brand-blue py-16 lg:py-24" data-id="element-124" data-mp="36w5ghivl4q14">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 lg:grid-cols-[1fr_1.05fr] lg:gap-16 lg:px-8" data-id="element-125" data-mp="3go02rzw1e9g5">
        <div className="text-white" data-id="element-126" data-mp="3lml6486l598t">
          <h2 className="font-display text-3xl leading-tight tracking-tight sm:text-4xl lg:text-5xl" data-id="element-127" data-mp="3lnmhkdrijxr2">
            GET YOUR FREE ESTIMATE.
          </h2>
          <p className="mt-4 max-w-md text-lg text-white/90" data-id="element-128" data-mp="3un9i6xcf4zj2">
            Tell Mason what needs cleaning and you will have a flat price back —
            usually the same day. No deposit, no pushy follow-ups.
          </p>

          <a href={business.phoneHref} className="mt-8 inline-flex items-center gap-3 rounded-2xl bg-white/15 px-6 py-5 ring-1 ring-white/25 transition-colors hover:bg-white/25" data-id="element-129" data-mp="8fjf0tz6u6d0">
            <Phone className="h-6 w-6" aria-hidden="true" data-id="element-130" data-mp="i4t5k5edvgz0" />
            <span data-id="element-131" data-mp="m7zks2jh4ihm">
              <span className="block text-xs font-bold uppercase tracking-wide text-white/80" data-id="element-132" data-mp="m8heosinykmd">
                Prefer to talk? Call or text
              </span>
              <span className="font-display text-2xl tracking-tight" data-id="element-133" data-mp="r4ga302et2wa">
                {business.phone}
              </span>
            </span>
          </a>

          <p className="mt-6 text-sm font-semibold text-white/80" data-id="element-134" data-mp="2j9n5ou18tyty">
            {business.hours} · {business.city} &amp; surrounding towns
          </p>
        </div>

        <div className="rounded-3xl bg-white p-7 shadow-xl sm:p-9" data-id="element-135" data-mp="2s8iemdvo9n0y">
          {status === 'success' ? <div className="flex h-full min-h-72 flex-col items-center justify-center text-center" data-id="element-136" data-mp="36x5438f0jv5w">
              <CheckCircle2 className="h-14 w-14 text-brand-teal" aria-hidden="true" data-id="element-137" data-mp="31zmt7chfr5v9" />
              <h3 className="mt-4 font-display text-2xl tracking-tight text-brand-navy" data-id="element-138" data-mp="3fy30b4j7mydx">
                REQUEST SENT!
              </h3>
              <p className="mt-3 max-w-sm text-base text-brand-navy/70" data-id="element-139" data-mp="1lklkk3p1r5tg">
                Mason will reach out shortly with your flat-rate price. Need it
                sooner? Call or text {business.phone}.
              </p>
            </div> : <form onSubmit={handleSubmit} noValidate data-id="element-140" data-mp="3s9dr0y3qrdzv">
              <fieldset data-id="element-141" data-mp="132kwnjvjn1o">
                <legend className="text-sm font-bold text-brand-navy" data-id="element-142" data-mp="11hth6suwk81">
                  What do you need cleaned?
                </legend>
                <div className="mt-3 flex flex-wrap gap-2.5" data-id="element-143" data-mp="3jeftfdpnfd27">
                  {services.map(service => {
                const active = selected.includes(service.id);
                return <button key={service.id} type="button" onClick={() => toggleService(service.id)} aria-pressed={active} className={`rounded-full px-4 py-2.5 text-sm font-bold transition-colors ${active ? 'bg-brand-navy text-white' : 'bg-brand-sky text-brand-navy hover:bg-brand-light/60'}`} data-id="element-144" data-mp="39kpa0n8dpstd">
                        {service.name}
                      </button>;
              })}
                </div>
              </fieldset>

              <div className="mt-6 grid gap-4 sm:grid-cols-2" data-id="element-145" data-mp="432qwf0m5zos">
                <label className="block" data-id="element-146" data-mp="41hx4rm4ikrz">
                  <span className="text-sm font-bold text-brand-navy" data-id="element-147" data-mp="3v9mbun05z60t">
                    Name
                  </span>
                  <input type="text" name="name" required autoComplete="name" className="mt-1.5 w-full rounded-xl border border-brand-navy/15 px-4 py-3 text-base text-brand-navy outline-none focus:border-brand-blue focus:ring-2 focus:ring-brand-blue/25" data-id="element-148" data-mp="3r80qed9kdjf0" />
                </label>
                <label className="block" data-id="element-149" data-mp="37k1f91b38a92">
                  <span className="text-sm font-bold text-brand-navy" data-id="element-150" data-mp="37j01uq6lnbo6">
                    Phone
                  </span>
                  <input type="tel" name="phone" required autoComplete="tel" className="mt-1.5 w-full rounded-xl border border-brand-navy/15 px-4 py-3 text-base text-brand-navy outline-none focus:border-brand-blue focus:ring-2 focus:ring-brand-blue/25" data-id="element-151" data-mp="33kkaka3hjh4y" />
                </label>
              </div>

              <label className="mt-4 block" data-id="element-152" data-mp="zcg5ul5vc87h">
                <span className="text-sm font-bold text-brand-navy" data-id="element-153" data-mp="zdr82gjo17wh">
                  Street address
                </span>
                <input type="text" name="address" required autoComplete="street-address" className="mt-1.5 w-full rounded-xl border border-brand-navy/15 px-4 py-3 text-base text-brand-navy outline-none focus:border-brand-blue focus:ring-2 focus:ring-brand-blue/25" data-id="element-154" data-mp="1496l569umzru" />
              </label>

              <label className="mt-4 block" data-id="element-155" data-mp="liotl50r6a82">
                <span className="text-sm font-bold text-brand-navy" data-id="element-156" data-mp="djadyxhpeu4c">
                  Anything we should know?{' '}
                  <span className="font-semibold text-brand-navy/50" data-id="element-157" data-mp="9hfbhpo1eaoz">
                    (optional)
                  </span>
                </span>
                <textarea name="details" rows={3} className="mt-1.5 w-full resize-none rounded-xl border border-brand-navy/15 px-4 py-3 text-base text-brand-navy outline-none focus:border-brand-blue focus:ring-2 focus:ring-brand-blue/25" data-id="element-158" data-mp="nbpz23oarytg" />
              </label>

              {error && <p role="alert" className="mt-4 text-sm font-semibold text-red-600" data-id="element-159" data-mp="4k6xm19x8stj">
                  {error}
                </p>}

              <button type="submit" disabled={status === 'submitting'} className="mt-6 inline-flex w-full items-center justify-center gap-2 rounded-full bg-brand-blue px-6 py-4 text-base font-bold text-white transition-colors hover:bg-brand-blue-dark disabled:opacity-70" data-id="element-160" data-mp="1fykcwhqlzzxy">
                {status === 'submitting' && <Loader2 className="h-5 w-5 animate-spin" aria-hidden="true" data-id="element-161" data-mp="2xtt680bicnix" />}
                {status === 'submitting' ? 'Sending…' : 'Send My Free Estimate'}
              </button>
              <p className="mt-3 text-center text-xs font-semibold text-brand-navy/50" data-id="element-162" data-mp="2oxc39kdarvy9">
                No spam, no obligation. Your info stays with {business.owner}.
              </p>
            </form>}
        </div>
      </div>
    </section>;
}